import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AccountServiceProvider } from '../../providers/account-service/account-service';
import * as abc from 'src/assets/js/masonry.pkgd.min.js';
import Masonry from 'masonry-layout';
import * as imagesLoaded from 'src/assets/js/imagesloaded.pkgd.min.js';

@Component({
	selector      : 'app-innernews',
	templateUrl   : './innernews.component.html',
	encapsulation : ViewEncapsulation.None,
	host: {
		'(window:resize)': 'onResize($event)'
	}
})

export class InnernewsComponent implements OnInit {
	@Input() newsData  : any;
	@Input() newsArray : any = [];
	public news_data = [];
	public error_message : any;
	public loadMoreButton     : boolean = true;
	public showMoreButton     : boolean = true;	
	public error_message_show : boolean = false;
	public isMobile           : boolean;

	constructor(
		private router         : Router,
		private accountService : AccountServiceProvider,		
	) {
		if ( devicePixelRatio > 1.5 && document.body.clientWidth < 767 )
            this.isMobile = true;
        else
            this.isMobile = false;
		/* routing */
		this.router.routeReuseStrategy.shouldReuseRoute = function () {
      		return false; 
    	};
    	/* routing */
    	this.loadMoreButton = false;
	}

	ngOnInit() {}

	moreNews( default_limit, prev_offset, total ) {
		this.loadMoreButton = true;
		this.showMoreButton = false;
		document.getElementById( 'loadnews' ).classList.add( 'loading-news' );
		let next_offset = parseInt( prev_offset ) + parseInt( default_limit );
		let params = {
			'offset' : next_offset,
			'limit'  : default_limit,
		};
		this.newsData.offset = params.offset;
		this.accountService.getMoreNews( params ).then( ( response: any ) => {
			if ( 'Ok' === response.status ) {
				this.news_data = response.data;				
				for ( let val of this.news_data ) {
					this.newsArray.push(val);
				}
				if ( total == this.newsArray.length )
					this.showMoreButton = false;
				else
					this.showMoreButton = true;				
				this.ngAfterViewInit();
			} else {
				this.error_message_show = true;
				if ( '3111' == response.errcode ) {
					this.error_message = 'Oops, looks like something went wrong!';
				} else {
					this.error_message = response.message;
				}
			}
			this.loadMoreButton = false;
		});
	}

	ngAfterViewInit() {
		if ( false === this.isMobile )
			setTimeout (
				() => {
					this.addMasonry();
				}, 300
			);
	}

	onResize(event) {
		this.addMasonry();
	}

	addMasonry() {
		if ( document.querySelector( '.news-grid' ) ) {
			var newsElem = document.querySelector( '.news-grid' );
			var newsElemmsnry = new Masonry( newsElem, {
				itemSelector: '.news-grid-item',
				columnWidth: '.grid-sizer-3',
				horizontalOrder: true,
				percentPosition: true,
			});
			imagesLoaded( newsElem ).on( 'progress', function() {
				newsElemmsnry.layout();
			});
		}
	}
}